<template>
    <div class="select">
        <input type="text" v-model="selectedValue" style="display: none;"/>

        <!-- 非 fixed 模式才使用背景遮罩關閉 -->
        <div v-if="!fixedPosition" class="select-bg"
            :class="[{'show':triggerSelects==true}]"
        ></div>

        <div class="select-obj" ref="selectObj" >
            <div class="input-content" 
                tabindex="0"
                :class="{'disabled':disabled}" 
                @click="triggerSelectList"
                @keydown.down.prevent="triggerSelectList"
                @keydown.enter.prevent="triggerSelectList"
            >
                <span>{{ selectedTargetValueName }}</span>
            </div>
            <i class=" align-middle fas fa-fw fa-chevron-down"
                @click="triggerSelectList"
            ></i>
            <!-- 一般定位模式 -->
            <div v-if="!fixedPosition"
                class="select-list"
                ref="selectList"
                :class="[{'show':triggerSelects==true},{'top':dir=='top'}]"
            >
                <div class="p-2">
                    <input type="text" class="form-control" placeholder=""
                        ref="searchInput"
                        v-model="keyWord"
                        @input="keyInSearchWord"
                        @keydown.down.prevent="onKeyDown"
                        @keydown.up.prevent="onKeyUp"
                        @keydown.enter.prevent="onKeyEnter"
                        @keydown.esc.prevent="onKeyEsc"
                    >
                </div>
                <ul ref="optionsList">
                    <li v-for="(select,index) in selects" :key="index"
                        :class="{'active': highlightIndex === index}"
                        @click="selectTargetOption(select)"
                        @mouseenter="onMouseEnterOption(index)"
                    >
                        <span>{{ select.name }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- fixed 定位模式：使用 Teleport 掛至 body 避免被 overflow 裁切 -->
        <Teleport to="body" v-if="fixedPosition">
            <div
                v-show="triggerSelects"
                class="select-list select-list-fixed"
                ref="selectList"
                :style="fixedStyle"
            >
                <div class="p-2">
                    <input type="text" class="form-control" placeholder=""
                        ref="searchInput"
                        v-model="keyWord"
                        @input="keyInSearchWord"
                        @keydown.down.prevent="onKeyDown"
                        @keydown.up.prevent="onKeyUp"
                        @keydown.enter.prevent="onKeyEnter"
                        @keydown.esc.prevent="onKeyEsc"
                    >
                </div>
                <ul ref="optionsList">
                    <li v-for="(select,index) in selects" :key="index"
                        :class="{'active': highlightIndex === index}"
                        @click="selectTargetOption(select)"
                        @mouseenter="onMouseEnterOption(index)"
                    >
                        <span>{{ select.name }}</span>
                    </li>
                </ul>
            </div>
        </Teleport>
    </div>
</template>
<script>
export default {
    name: 'selectedDropMenu',
    props:{
        disabled:{
            type:Boolean,
            default:false
        },
        modelValue:{
            type:String,
            default:''
        },
        options:{
            type:Array,
            default: () => []
        },
        dir:{
            type:String,
            default:''
        },
        /** 使用 fixed 定位模式，在 overflow:auto 的容器內不會被裁切 */
        fixedPosition:{
            type:Boolean,
            default:false
        }
    },
    
    data(){
        return {
            selectedValue: this.modelValue, // 初始化选中值
            triggerSelects:false,
            selects:this.options,
            selectsTarget:'',
            keyWord:'',
            /** fixed 模式下的下拉清單位置樣式 */
            fixedStyle: {},
            /** 目前鍵盤/懸停高亮選中的索引 */
            highlightIndex: -1
        }
    },
    watch:{
        options: {
            handler() {
                this.selects = this.options 
            },
            deep:false
        }
    },
    computed:{
        selectedTargetValueName(){
            const selects = this.selects.find(item=> item.value == this.modelValue)
            
            return selects ? selects.name : ''
        }
    },
    components: {},
    methods:{
        emitUpdate() {
            this.$emit('update:modelValue', this.selectedValue);
        },
        triggerSelectList(){
            try {
                if ( this.disabled ) return
                const willOpen = !this.triggerSelects
                this.triggerSelects = willOpen
                if ( willOpen ) {
                    const currentIdx = this.selects.findIndex(item => item.value == this.selectedValue)
                    this.highlightIndex = currentIdx >= 0 ? currentIdx : 0
                    this.$nextTick(() => {
                        if ( this.fixedPosition ) {
                            this.updateFixedPosition()
                        }
                        this.focusSearchInput()
                        this.scrollToHighlighted()
                    })
                }
            } catch (error) {
                console.error('[selectedDropMenu] triggerSelectList 失敗:', error)
            }
        },
        /**
         * 計算 fixed 模式下的下拉清單位置，並偵測螢幕邊界自動翻轉
         */
        updateFixedPosition(){
            if ( !this.$refs.selectObj ) return
            const rect = this.$refs.selectObj.getBoundingClientRect()
            const listWidth = 240
            const listMaxHeight = 250
            const viewportW = window.innerWidth
            const viewportH = window.innerHeight
            const spaceBelow = viewportH - rect.bottom
            const spaceAbove = rect.top

            // 垂直方向：下方空間不足時向上展開
            let top, bottom
            if ( spaceBelow < listMaxHeight && spaceAbove > spaceBelow ) {
                bottom = viewportH - rect.top + 2
                top = 'auto'
            } else {
                top = rect.bottom + 2
                bottom = 'auto'
            }

            // 水平方向：右邊超出螢幕時向左對齊
            let left
            if ( rect.left + listWidth > viewportW ) {
                left = Math.max(4, viewportW - listWidth - 4)
            } else {
                left = rect.left
            }

            this.fixedStyle = {
                position: 'fixed',
                top: top === 'auto' ? 'auto' : `${top}px`,
                bottom: bottom === 'auto' ? 'auto' : `${bottom}px`,
                left: `${left}px`,
                width: `${Math.max(rect.width, listWidth)}px`,
                zIndex: 9999
            }
        },
        keyInSearchWord(){
            try {
                this.$debug('keyWord',this.keyWord)
                this.selects = this.options.filter(option => option.name.toLowerCase().includes(this.keyWord.toLowerCase()))
                this.highlightIndex = this.selects.length > 0 ? 0 : -1
                this.scrollToHighlighted()
            } catch (error) {
                console.error('[selectedDropMenu] keyInSearchWord 失敗:', error)
            }
        },
        /**
         * 鍵盤向下鍵巡航
         */
        onKeyDown() {
            try {
                if (!this.selects || this.selects.length === 0) return
                if (this.highlightIndex < this.selects.length - 1) {
                    this.highlightIndex++
                } else {
                    this.highlightIndex = 0
                }
                this.scrollToHighlighted()
            } catch (error) {
                console.error('[selectedDropMenu] onKeyDown 失敗:', error)
            }
        },
        /**
         * 鍵盤向上鍵巡航
         */
        onKeyUp() {
            try {
                if (!this.selects || this.selects.length === 0) return
                if (this.highlightIndex > 0) {
                    this.highlightIndex--
                } else {
                    this.highlightIndex = this.selects.length - 1
                }
                this.scrollToHighlighted()
            } catch (error) {
                console.error('[selectedDropMenu] onKeyUp 失敗:', error)
            }
        },
        /**
         * 鍵盤 Enter 選取高亮選項
         */
        onKeyEnter() {
            try {
                if (!this.selects || this.selects.length === 0) return
                if (this.highlightIndex >= 0 && this.highlightIndex < this.selects.length) {
                    this.selectTargetOption(this.selects[this.highlightIndex])
                }
            } catch (error) {
                console.error('[selectedDropMenu] onKeyEnter 失敗:', error)
            }
        },
        /**
         * 鍵盤 Esc 關閉選單
         */
        onKeyEsc() {
            try {
                this.triggerSelects = false
            } catch (error) {
                console.error('[selectedDropMenu] onKeyEsc 失敗:', error)
            }
        },
        /**
         * 滑鼠移入選項時同步更新高亮索引
         * @param {number} index - 選項索引
         */
        onMouseEnterOption(index) {
            try {
                this.highlightIndex = index
            } catch (error) {
                console.error('[selectedDropMenu] onMouseEnterOption 失敗:', error)
            }
        },
        /**
         * 將目前高亮之選項滾動至可見區域
         */
        scrollToHighlighted() {
            try {
                this.$nextTick(() => {
                    const listEl = this.$refs.optionsList
                    if (!listEl) return
                    const ul = Array.isArray(listEl) ? listEl[0] : listEl
                    if (!ul) return
                    const activeItem = ul.children[this.highlightIndex]
                    if (activeItem && typeof activeItem.scrollIntoView === 'function') {
                        activeItem.scrollIntoView({
                            block: 'nearest',
                            behavior: 'smooth'
                        })
                    }
                })
            } catch (error) {
                console.error('[selectedDropMenu] scrollToHighlighted 失敗:', error)
            }
        },
        /**
         * 自動聚焦至搜尋輸入框
         */
        focusSearchInput() {
            try {
                const inputEl = this.$refs.searchInput
                if (!inputEl) return
                const target = Array.isArray(inputEl) ? inputEl[0] : inputEl
                target?.focus()
            } catch (error) {
                console.error('[selectedDropMenu] focusSearchInput 失敗:', error)
            }
        },
        selectTargetOption(target=null){
            this.selectsTarget = target.name
            this.selectedValue = target.value
            this.emitUpdate()
            this.triggerSelects = false
        },
        handleClickOutside(event) {
            const inObj = this.$refs.selectObj && this.$refs.selectObj.contains(event.target)
            const inList = this.$refs.selectList && this.$refs.selectList.contains(event.target)
            if ( !inObj && !inList ) {
                this.triggerSelects = false
            }
        },
        handleScrollOrResize(){
            if ( this.triggerSelects && this.fixedPosition ) {
                // scroll 時同步更新位置
                this.updateFixedPosition()
            }
        },
    },
    mounted(){
        this.selectTargetOption(this.options[0] ? this.options[0] : [] )
        document.addEventListener('click', this.handleClickOutside);
        if ( this.fixedPosition ) {
            window.addEventListener('scroll', this.handleScrollOrResize, true)
            window.addEventListener('resize', this.handleScrollOrResize)
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('scroll', this.handleScrollOrResize, true)
        window.removeEventListener('resize', this.handleScrollOrResize)
    },
    created(){}
}
</script>
<style>
.select > .select-bg{
    display: none;
    width: 100vw;
    height: 100vh;
    position: fixed;
    /* background-color: rgba(0, 0, 0, 0.145); */
    top: 0;
    left: 0;
}
.select-bg.show{
    display: block;
    z-index: 3021;
}
.select-list.show.top{
    top: -6px;
    transform: translateY(-100%);
}
.select-obj{
    position: relative;
}

.select-obj > .fa-chevron-down{
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    right: .25rem;
    font-size: 12px;
    color: #495057;

}
.select-obj > .input-content {
    /* border: 1px solid #ced4da;
    background-color: #ffffff;
    font-size: .9375rem;
    font-weight: 400;
    line-height: 1.5;
    padding: .25rem .7rem;
    border-radius: .2rem; */
    appearance: none;
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    color: #495057;
    display: block;
    font-size: .9375rem;
    font-weight: 400;
    line-height: 1.5;
    padding: .25rem .7rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    width: 100%;
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px;
    padding-right: 2rem;
    min-height: 32.5px;
    white-space: nowrap;        /* 不換行 */
    overflow: hidden;           /* 超出部分隱藏 */
    text-overflow: ellipsis;    /* 當文字超出時顯示省略號 */
}
.input-content.disabled{
    background-color: #f5f5f5;
    border: 1px solid #f5f5f5;
}
.select-list{
    display: none;
    position: absolute;
    background-color: #f1f7fe;
    width: fit-content;
    min-width: 200px;
    border-radius: 0.3rem;
    margin-top: 0.15rem;
    box-shadow: 0px 0px 10px #6a6a6a63;
    border: 1px solid #c4dbfd;
}

.select-list.show{
    display: block;
    z-index: 3051;
}

/* fixed 定位模式：teleport 到 body，不受 overflow 裁切 */
.select-list-fixed{
    display: block;
    position: fixed;
    background-color: #f1f7fe;
    min-width: 200px;
    border-radius: 0.3rem;
    box-shadow: 0px 4px 16px rgba(0,0,0,0.18);
    border: 1px solid #c4dbfd;
    z-index: 9999;
}
.select-list input {
    width: 100%;
    min-width: 200px;
}
.select-list > ul {
    list-style: none;
    padding: 0px;
    margin-bottom: 0px;
    max-height: 200px;
    overflow-y: auto;
}
.select-list > ul > li {
    padding: 0.25rem 0.75rem 0.25rem 0.75rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
}
.select-list > ul > li:last-child {
    margin-bottom: 0.25rem;
}
.select-list > ul > li.active,
.select-list > ul > li:hover{
    background-color: #d7d7d7;
}
</style>
  